interface UserProps {
  firstname: string;
  lastname: string;
  roles: string[];
  initials?: string;
}

const appLinks = {
  admin: {
    label: 'Admin Dashboard',
    url: '/admin/dashboard',
  },
  frontdesk: {
    label: 'Front Desk',
    url: '/admin/frontdesk',
  },
  np: {
    label: 'Nurse Practitioner Dashboard',
    url: '/np/dashboard',
  },
  npView: {
    label: 'Nurse Practitioner Dashboard',
    url: '/np/dashboard/referrals?view=np',
  },
  npCoordinator: {
    label: 'NP Coordinator Dashboard',
    url: '/np/dashboard/referrals?view=np_coordinator',
  },
  radiology: {
    label: 'Radiology Dashboard',
    url: '/radiologist/portal/dashboard',
  },
  technologist: {
    label: 'Technologist Dashboard',
    url: '/technologist/dashboard'
  },
  user: {
    label: 'User Dashboard',
    url: '/user/dashboard',
  },
};

const getLocalPort = (linkUrl: string) => {
  if (typeof window !== 'undefined' && !window.location.href.includes('localhost')) {
    return linkUrl;
  }
  switch (linkUrl) {
    case '/admin/dashboard':
    case '/admin/frontdesk':
    case '/radiologist/portal/dashboard':
    case '/np/old/dashboard':
      return `dev.localhost:5000${linkUrl}`;

    case '/np/dashboard':
    case '/np/dashboard?view=np_coordinator':
    case '/np/dashboard?view=np':
      return `dev.localhost:3050${linkUrl}`;

    case '/radiologist/dashboard/':
    case '/technologist/dashboard':
      return `dev.localhost:3060${linkUrl}`;

    case '/user/dashboard':
    case '/user/profile':
      return `dev.localhost:3020${linkUrl}`;

    default:
      return linkUrl;
  }
};

const getAppLinks = () => {
  const adjustedAppLinks = appLinks;
  Object.entries(appLinks).map(
    ([appLinkKey, appLinkValue]) =>
      // @ts-ignore
      (adjustedAppLinks[appLinkKey].url = getLocalPort(appLinkValue.url))
  );
  return adjustedAppLinks;
};

export const getAppLinksForUser = (user: UserProps) => {
  const hasAdminAccess = user.roles.some((role) => ['admin', 'superadmin'].includes(role));
  const hasFrontdeskAccess = user.roles.some((role) => role === 'frontdesk');
  const hasNPAccess = user.roles.some((role) => role === 'np');
  const hasNPCoordinatorAccess = user.roles.some((role) => role === 'np_coordinator');
  const hasUserAccess = user.roles.some((role) => role === 'user');
  const hasTechDashboardAccess = user.roles.some((role) => role === 'technologist');

  const hasRadiologyAccess = user.roles.some((role) =>
    ['radiologist', 'technician', 'coordinator'].includes(role)
  );

  const appLinks = getAppLinks();

  const userAppLinks = [];

  if (hasAdminAccess) {
    userAppLinks.push(appLinks.admin);
  }

  if (hasFrontdeskAccess) {
    userAppLinks.push(appLinks.frontdesk);
  }

  if (hasNPAccess) {
    if (hasNPCoordinatorAccess) {
      userAppLinks.push(appLinks.npView);
    } else {
      userAppLinks.push(appLinks.np);
    }
  }

  if (hasNPCoordinatorAccess) {
    userAppLinks.push(appLinks.npCoordinator);
  }

  if (hasRadiologyAccess) {
    userAppLinks.push(appLinks.radiology);
  }

  if (hasTechDashboardAccess) {
    userAppLinks.push(appLinks.technologist);
  }

  if (hasUserAccess) {
    userAppLinks.push(appLinks.user);
  }

  return userAppLinks;
};
